export default {
  education: {
    items: {
      item1: {
        degree: "Bachelor of Computer Information Systems",
        school: "Mount Royal University",
        location: "Calgary, AB",
        duration: "2021 - Present",
        details: {
          detail1: "Dean's Honor Roll 2024 / Cumulative GPA 3.1.",
          detail2: "Anticipated graduation 2026."
        }
      }
    }
  },
  work: {
    items: {
      item1: {
        title: "Front-End Web Developer",
        company: "Milano Nails Spa / Nails of America",
        location: "Dallas, TX",
        duration: "Nov 2022 – Mar 2023",
        responsibilities: {
          resp1: "Designed and implemented a visually appealing and user-friendly site enabling online bookings boosting overall appointments by around 130 customers per week.",
          resp2: "Optimized the website for mobile devices, ensuring a seamless user experience across all platforms and increasing mobile traffic and in addition to social media increased appointments and overall community interest."
        }
      },
      item2: {
        title: "Full-Stack Developer",
        company: "Smile of Compassion Projects",
        location: "Calgary, AB",
        duration: "Sept 2019 – Present",
        responsibilities: {
          resp1: "Spearheaded the redesign of a non-profit organization site, resulting in a 70% increase in user visits and a 50% increase in proceeds.",
          resp2: "Implemented cost-effective web solutions reducing operational expenses by nearly 90%.",
          resp3: "Conducted tutorial sessions to train non-profit staff in website management, enabling them to update content independently."
        }
      }
    }
  }
}
